"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchHelper = void 0;
var SearchHelper = /** @class */ (function () {
    function SearchHelper() {
        this.columnSelectors = [];
    }
    SearchHelper.prototype.addColumnSelector = function (columnSelector) {
        this.columnSelectors.push(columnSelector);
        return this;
    };
    SearchHelper.prototype.search = function (items, searchText) {
        var _this = this;
        if (!this.columnSelectors.length) {
            throw new Error('Column Selectors must be set to perform the search');
        }
        if (!searchText.trim().length) {
            return items;
        }
        var searchToLower = searchText.toLowerCase();
        return items.filter(function (item) {
            return _this.columnSelectors.some(function (cs) {
                var text = cs(item);
                if (text != null) {
                    return text.toLowerCase().includes(searchToLower);
                }
                return false;
            });
        });
    };
    return SearchHelper;
}());
exports.SearchHelper = SearchHelper;
exports.default = SearchHelper;
